import logger from '../../../util/logger';
import { VAULT_KYC_CREATE_QUERY } from './graphqlQuery';

export const requestBodyFormatter =
  ({
    kycAddressRegion,
    kycPercentOwnership,
    kycTitle,
    kycIsOwner,
  }: {
    kycAddressRegion: string;
    kycPercentOwnership: number;
    kycTitle: string;
    kycIsOwner: boolean;
  }) =>
  (formValues: Record<string, string>): VgsRequestBody => {
    logger('OrgConfirmationWithCreateKyc vault submit', false, formValues);
    return {
      query: VAULT_KYC_CREATE_QUERY,
      variables: {
        rawKycFirstName: formValues.kycFirstName,
        rawKycLastName: formValues.kycLastName,
        rawKycPhoneNumber: formValues.kycPhoneNumber,
        rawKycEmail: formValues.kycEmail,
        rawKycDob: {
          month: formValues.kycDobMonth,
          day: formValues.kycDobDay,
          year: formValues.kycDobYear,
        },
        rawKycAddress: {
          street: formValues.kycAddressStreet,
          unit: formValues.kycAddressUnit,
          city: formValues.kycAddressCity,
          region: kycAddressRegion,
          postalCode: formValues.kycAddressPostalCode,
        },
        rawKycSsn: formValues.kycSsn,
        percentOwnership: kycPercentOwnership,
        director: false,
        executive: true,
        representative: true,
        owner: kycIsOwner,
        title: kycTitle,
      },
    };
  };
